import loadable from "@loadable/component";

export const ModelloPraticaView = loadable(() =>
  import("./ModelloPraticaView/ModelloPraticaView")
);
export const AreaPersonaleView = loadable(() =>
  import("./AreaPersonaleView/AreaPersonaleView")
);
export const AreaOperatoreView = loadable(() =>
  import("./AreaOperatoreView/AreaOperatoreView")
);
